import React from 'react';
import {makeStyles} from '@material-ui/core';
import Grid from "@material-ui/core/Grid";
import Hidden from "@material-ui/core/Hidden";

const useStyles = makeStyles(() => ({
    root: {
        backgroundImage: 'url(/image/topBand/bgBand.png)',
        backgroundSize: '100% 100%',
        minHeight: '229px',
        padding: '2%',
        paddingLeft: '10%'
    },
    rootSmall: {
        backgroundImage: 'url(/image/topBand/bgBand.png)',
        backgroundSize: '100% 100%',
    },
    img: {
        width: '96%',
        margin: '2%'
    }
}));

function TopBand(){
    const classes = useStyles();

    return (
        <Grid container>
            <Hidden only={['xs','sm']}>
                <Grid item md={12} className={classes.root}>
                    <img src="/image/topBand/topBand.png" alt="Bandeau avec logo d'entreprise"/>
                </Grid>
            </Hidden>
            <Hidden only={['md','lg','xl']}>
                <Grid item className={classes.rootSmall} xs={12}>
                    <img src="/image/topBand/topBand.png" alt="Bandeau avec logo d'entreprise" className={classes.img}/>
                </Grid>
            </Hidden>
        </Grid>
    )
}

export default TopBand